/**
 * Action handler for opening the Stat File Upload modal.
 */

import { Dispatch } from "@reduxjs/toolkit";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

/**
 * Dispatches the action to open the STAT_FILE_UPLOAD_MODAL.
 *
 * @param dispatch - Redux dispatch function
 */
export const handleStatFileUploadClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.STAT_FILE_UPLOAD_MODAL,
    }),
  );
};
